var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M180 20H20v160h160V20zM0 0v200h200V0H0z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }